'use client';

import { Footer } from '@britishcouncil/react-registration-platform';

import styled from '@emotion/styled';

import { useAppSettings } from '@/utils/appsettings/useAppSettings';

export const AppFooter = () => {
  const appSettings = useAppSettings();

  return (
    <Root>
      <Footer
        copy={[
          `© ${new Date().getFullYear()} British Council`,
          "The United Kingdom's international organisation for cultural relations and educational opportunities.",
          'A registered charity: 209131 (England and Wales) SC037733 (Scotland).',
          `V: ${appSettings?.appVersion}`,
        ]}
        routes={[
          { external: true, path: 'https://www.britishcouncil.org/terms', text: 'Terms of use' },
          { external: true, path: 'https://www.britishcouncil.org/accessibility', text: 'Accessibility' },
          { external: true, path: 'https://www.britishcouncil.org/privacy-cookies', text: 'Privacy and cookies' },
          { external: true, path: 'https://www.britishcouncil.org/privacy-cookies/data-protection', text: 'Data Protection' },
        ]}
      />
    </Root>
  );
};

const Root = styled.div`
  margin-top: 42px;
  footer > div {
    width: var(--max-content-width);
    margin: 0 auto;
  }
`;
